/** PRODUCT GROUP CODES */
export const GPR_CONSULT = "GPR01000";

/** PRODUCT CODES */
export const PRO_CONSULT = "PRO01001";

/** APPOINTMENT CODES */
export const APT_NOW = "APT01001";
export const APT_CONSULT = "APT01002";